import MdeEditorContainer from "../../../components/miscellaneous/editors/mdeEditor";

const MdeEditor = () => {
  return <MdeEditorContainer />;
};

export default MdeEditor;
